// The Mao's per-click coin value as a PURE function, so the game (seasonManager.getClickValue) and the server (a guest's "Work" in a host's
// kingdom, server/stays.js) use the same formula. base 5 (+1 per PhD) + ClickEconomy.perPeasant per healthy peasant + perScribe per healthy scribe
// (1 and 2 since V1.18 — halved), doubled while citizens are
// sent to the FIELDS. (Injured / resting citizens are the caller's business: pass only the ones that count.)

import { ClickEconomy, WorkModes } from '../config/balance.js'

export function computeClickValue({ peasants = 0, scribes = 0, phd = 0, fields = false } = {}) {
  const { maoBase, perPeasant, perScribe, phdBonus, fieldsMultiplier } = ClickEconomy
  let v = (maoBase + phd * phdBonus) + perPeasant * peasants + perScribe * scribes
  if (fields) v *= fieldsMultiplier
  return Math.round(v)
}

// From a saved game state (what the server has): everyone counts as healthy and working.
export function clickValueFromState(state) {
  const p = state?.profile ?? {}
  const k = state?.kingdoms?.[p.homeKingdom] ?? {}
  const goons = k.goons ?? {}
  const phd = Object.values(p.degrees ?? {}).filter((t) => t === 'PHD').length
  return computeClickValue({ peasants: Number(goons.PEASANT_CAT ?? 0), scribes: Number(goons.SCRIBE_CAT ?? 0), phd, fields: (k.workMode ?? WorkModes.FIELDS) === WorkModes.FIELDS })
}
